import React from 'react';

export default ({ location }) => (
    <div style={{flexDirection: 'row', alignItems: 'center', minHeight: '100vh'}}>
        <div style={{width: '100%', paddingRight: '15px', paddingLeft: '15px', margin: 'auto'}}>
            <div style={{justifyContent: 'center', flexWrap: 'wrap'}} >
                <h3>Oops,</h3>
                <h3>No match for <code>{location.pathname}</code></h3>
            </div>
        </div>
    </div>
);



// WEBPACK FOOTER //
// ./src/pages/NoMatch.js